// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pt-9";
export var arrowButtonContainer = "_pt-5";
export var arrowButtonIcon = "_pt-6";
export var carouselArrowButton = "_pt-2";
export var carouselElementContainer = "_pt-1";
export var currentSlide = "_pt-8";
export var left = "_pt-3";
export var otherSlide = "_pt-a";
export var productCarouselContainer = "_pt-0";
export var right = "_pt-4";
export var sliderOverflow = "_pt-7";